import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ficha-medica2',
  templateUrl: './ficha-medica2.component.html',
  styleUrls: ['./ficha-medica2.component.css']
})
export class FichaMedica2Component implements OnInit {

  selectedTab: string = 'Anamnesis';

  constructor() { }

  ngOnInit(): void {
  }

}
